import React from 'react';
import { g_HttpReq } from '../utils/httpUtils';

const assetsPrefix = process.env.NODE_ENV === 'development' || process.env.DEBUG_BUILD === 'true' ? '/apiassets' : '/assets';

console.log('assetsPrefix:', assetsPrefix);

// /////////////////////////////////////////////////////////////////////////////////////////////
// ApiAssets ///////////////////////////////////////////////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////////
class apiAssets {
  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetsGet(props = {}) {
    return g_HttpReq.fetchGetJson(`${assetsPrefix}/v2`, props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetsGetHealthIssues(props = {}) {
    return g_HttpReq.fetchGetJson(`${assetsPrefix}/health`, props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetHealthIssueSetState(props = {}) {
    const { id, newState } = props;
    return g_HttpReq.fetchPostJson(`${assetsPrefix}/health/` + encodeURIComponent(id) + '/state', { newState });
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetHealthIssueDelete(aIssueId) {
    return g_HttpReq.fetchDeleteJson(`${assetsPrefix}/health/` + encodeURIComponent(aIssueId), null);
  }

  // Bulk Acknowledge multiple health issues
  // props: { ids: string[], state: 'acknowledged' | 'open' | 'cleared' }
  async apiAssetHealthIssueBulkSetState(props = {}) {
    return g_HttpReq.fetchPostJson(`${assetsPrefix}/health/bulk/state`, props);
  }

  // Bulk Delete multiple health issues
  // props: { ids: string[] }
  async apiAssetHealthIssueBulkDelete(props = {}) {
    return g_HttpReq.fetchPostJson(`${assetsPrefix}/health/bulk/delete`, props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetsGetDeleted(props = {}) {
    return g_HttpReq.fetchGetJson(`${assetsPrefix}/deleted`, props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetGet(props = {}) {
    if (!props.entityId) {
      throw new Error('Entity ID is required for apiAssetGet');
    }

    return g_HttpReq.fetchGetJson(assetsPrefix + '/' + encodeURIComponent(props.entityId), props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetCreate(props = {}) {
    return g_HttpReq.fetchPostJson(assetsPrefix, props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetCreateFromCSV(props = {}) {
    return g_HttpReq.fetchPostJson(assetsPrefix + '/create-many', { dataJson: props });
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetUpdate(props = {}) {
    return g_HttpReq.fetchPatchJson(assetsPrefix + '/' + encodeURIComponent(props.entityId), props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetActivate(props = {}) {
    return g_HttpReq.fetchPatchJson(assetsPrefix + '/activate/' + encodeURIComponent(props.entityId), props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetActivateAndInstall(props = {}) {
    return g_HttpReq.fetchPatchJson(assetsPrefix + '/activate-and-install/' + encodeURIComponent(props.entityId), props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetDelete(aAssetId) {
    return g_HttpReq.fetchDeleteJson(assetsPrefix + '/' + encodeURIComponent(aAssetId), null);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetRestore(aAssetId) {
    return g_HttpReq.fetchPostJson(`${assetsPrefix}/restore/` + encodeURIComponent(aAssetId), {});
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetsStatsGet(props = {}) {
    return g_HttpReq.fetchGetJson(assetsPrefix + '/statistics', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetAdminDeafultConfigGet(props = {}) {
    return g_HttpReq.fetchGetJson(assetsPrefix + '/default-admin-config', props);
  }

  async apiAssetsActivityReportGet(props = {}) {
    return g_HttpReq.fetchGetJson(assetsPrefix + '/asset-activity-report', props);
  }

  // ////////////////////////////////////////////////////////////////////////////////////////////
  async apiAssetsFilterGet(props = {}) {
    return g_HttpReq.fetchGetJson(assetsPrefix + '/top-assets', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////////
  async apiPutSignedUrl(props = {}) {
    return g_HttpReq.fetchPostJson(assetsPrefix + '/installation/media/presign', props);
  }

  async apiGetFileKeys(props = {}) {
    const { assetId } = props;
    return g_HttpReq.fetchGetJson(assetsPrefix + '/installation/media/' + encodeURIComponent(assetId), props);
  }

  async apiGetSignedUrls(props = {}) {
    const { assetId, mediaKey } = props;
    return g_HttpReq.fetchGetJson(assetsPrefix + '/installation/media/' + encodeURIComponent(assetId) + '/' + encodeURIComponent(mediaKey), props);
  }

  async apiInstalledAssetsGet(props = {}) {
    return g_HttpReq.fetchGetJson(assetsPrefix + '/installed-assets', props);
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  // Device Commands APIs
  // /////////////////////////////////////////////////////////////////////////////////////////////
  async apiCommandsGet(props = {}) {
    return g_HttpReq.fetchGetJson(`${assetsPrefix}/commands`, props);
  }

  async apiCommandGet(commandId) {
    return g_HttpReq.fetchGetJson(`${assetsPrefix}/commands/` + encodeURIComponent(commandId), {});
  }

  async apiCommandCreate(props = {}) {
    return g_HttpReq.fetchPostJson(`${assetsPrefix}/commands`, props);
  }

  async apiCommandUpdate(commandId, props = {}) {
    return g_HttpReq.fetchPatchJson(`${assetsPrefix}/commands/` + encodeURIComponent(commandId), props);
  }

  async apiCommandDelete(commandId) {
    return g_HttpReq.fetchDeleteJson(`${assetsPrefix}/commands/` + encodeURIComponent(commandId), null);
  }
}

const g_apiAssets = new apiAssets();
export default g_apiAssets;
